/**
 * 题目表单:单选/多选组件
 * @description 题目:单选/多选组件
 * @author mll
 * @date 2020-2-6
 */
import React from 'react';
import PropTypes from 'prop-types';
import 'antd/dist/antd.css';
import { Table, Input, Button, Popconfirm, Form, Upload, message } from 'antd';
import { framework_tool } from '../../../../tool'
let { WizAvatarUpload, ossFileUtils } = framework_tool;

export default class EditableTable extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                title: '序号',
                dataIndex: 'order',
                width: '8%',
                render: (text) => <div>{String.fromCharCode(text - 1 + 65)}</div>
            },
            {
                title: '选项内容',
                dataIndex: 'name',
                width: '52%',
                editable: true,
                render: (text) => <div>{text || '点击添加选项内容'}</div>
            },
            {
                title: '图片',
                dataIndex: 'imgUrl',
                width: '20%',
                render: (text, reocrd) =>
                    text && text !== '' ?
                        <img key={text} style={{ height: 100, width: 200 }} src={text} /> :
                        <div>无</div>
            },
            {
                title: '操作',
                dataIndex: 'operation',
                width: '20%',
                render: (text, record) =>
                    this.state.dataSource.length >= 1 ? [
                        <WizAvatarUpload
                            showUploadList={false}
                            beforeUpload={this.beforeUpload}
                            listType={'text'}
                            onChange={(files) => { this._changeImg(record, files[0]) }}
                            key={record && (record['order'] + '@upload')}
                            aspectRatio={200/100}
                        >
                            <a key={record && (record['order'] + '@upload-a')} style={{ paddingRight: 10 }}>{record['img'] && record['img'] !== '' ? '更换图片' : '插入图片'}</a>
                        </WizAvatarUpload>,
                        <a key={record && (record['order'] + '@a')} onClick={() => { this.handleDelete(record.key) }}>删除</a>
                    ] : null,
            },
        ];

        this.state = {
            dataSource: props.dataSource || [],
            count: props.dataSource.length || 0,
        };
    }

    /**
     * 初始化执行的方法
     */
    componentDidMount() {
        this.initialValue = []
        if (!this.initialValue.length && this.props.dataSource) {
            this.props.dataSource.forEach(e => {
                if (e.img && e.ing != '') {
                    e['imgUrl'] = getOssFilePath(e.img)
                    // ossFileUtils.getOssFile(
                    //     e.img,
                    //     e.fileName,
                    //     e.fileMimeType,
                    //     e.fileSize,
                    //     e.fileUri,
                    // )['thumbUrl']
                }
                this.initialValue.push(Object.assign({}, e))
            });
        }
        this._getDataSource()
    }

    /**
     * setState的钩子
     */
    _setState = ({ dataSource }) => {
        if (dataSource && dataSource.length) {
            dataSource.forEach(data => {
                this.initialValue && this.initialValue.forEach(initVlaue => {
                    if (data['id'] === initVlaue['id']) {
                        data['img'] = initVlaue['img']
                    }
                });
            });
        }
        this.setState({ dataSource })
    }

    /**
     * 数据变化的回调
     */
    _getDataSource() {
        let { getDataSource } = this.props;
        getDataSource && getDataSource(this.state.dataSource)
    }

    /**
     * 上传文件前的钩子：自定义校验
     */
    beforeUpload = (file, showMessage = true) => {
        const isLt1M = file.size / 1024 / 1024 < 0.488;
        if (!isLt1M && showMessage) {
            message.error('图片不得超过500KB!');
        }
        return isLt1M;
    }

    /**
     * 获取base64类型的图片
     */
    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    /**
     * 改变图片
     */
    _changeImg = (record, file) => {
        // ⭐ 暂时去除上传后校验文件是否符合对应大小
        // if (this.beforeUpload(file, false)) {
        let { dataSource } = this.state;
        let datas = Object.assign([], dataSource);
        datas && datas.length > 0 && datas.forEach(data => {
            if (data['key'] === record['key']) {
                data['img'] = file['fileId']
                data['imgUrl'] = file['thumbUrl']
            }
        });
        this.setState({
            dataSource: datas
        }, () => {
            //数据改变回调
            this._getDataSource()
        })
        // }
    }

    /**
     * 删除row
     */
    handleDelete = key => {
        let dataSource = [...this.state.dataSource];
        if (dataSource.length === 1) {
            message.error('选择题至少需要一个选项')
            return;
        }
        dataSource = dataSource.filter(item => item.key !== key);
        if (dataSource.length > 0) {
            for (let index = 0; index < dataSource.length; index++) {
                dataSource[index]['key'] = index
                dataSource[index]['order'] = index + 1
            }
        }
        this.setState({
            dataSource,
            count: --this.state.count
        }, () => {
            //数据改变回调
            this._getDataSource()
        });

    };

    /**
     * 增加row
     */
    handleAdd = () => {
        const { count, dataSource } = this.state;
        if (count === 26 || count > 26) {
            //选项前需要展示大写字母(A、B、C...)大写字母就26个
            message.error('选择不能超过26个');
            return;
        }
        let _count = count + 1
        const newData = {
            key: count,
            name: '',
            order: _count
        };
        this.setState({
            dataSource: [...dataSource, newData],
            count: _count
        }, () => {
            //数据改变回调
            this._getDataSource()
        });

    };

    /**
     * row编辑的保存
     */
    handleSave = row => {
        const newData = [...this.state.dataSource];
        const index = newData.findIndex(item => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        this.setState({ dataSource: newData }, () => {
            //数据改变回调
            this._getDataSource()
        });

    };

    render() {
        const { dataSource } = this.state;
        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        };
        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleSave,
                }),
            };
        });
        return (
            <div>
                <Button onClick={this.handleAdd} type="primary" style={{ marginBottom: 16 }}>
                    增加选项
                </Button>
                <Table
                    size='small'
                    components={components}
                    rowClassName={() => 'editable-row'}
                    bordered
                    dataSource={dataSource}
                    columns={columns}
                />
            </div>
        );
    }
}


/**
 * 默认值
 */
EditableTable.defaultProps = {
    dataSource: [
        {
            key: 0,
            name: '',
            img: '',
            order: 1
        }
    ]
}

/**
 * props入参校验
 */
EditableTable.propTypes = {
    dataSource: PropTypes.array,//数据源
    getDataSource: PropTypes.func,//数据改变的回调方法
}



const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
    state = {
        editing: false,
    };

    toggleEdit = () => {
        const editing = !this.state.editing;
        this.setState({ editing }, () => {
            if (editing) {
                this.input.focus();
            }
        });
    };

    save = e => {
        const { record, handleSave } = this.props;
        this.form.validateFields((error, values) => {
            if (error && error[e.currentTarget.id]) {
                return;
            }
            this.toggleEdit();
            handleSave({ ...record, ...values });
        });
    };

    renderCell = form => {
        this.form = form;
        const { children, dataIndex, record, title } = this.props;
        const { editing } = this.state;
        return editing ? (
            <Form.Item style={{ margin: 0 }}>
                {form.getFieldDecorator(dataIndex, {
                    rules: [
                        {
                            required: true,
                            message: `${title} 不能为空`,
                        },
                    ],
                    initialValue: record[dataIndex],
                })(<Input ref={node => (this.input = node)} onPressEnter={this.save} onBlur={this.save} />)}
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{ paddingRight: 24 }}
                onClick={this.toggleEdit}
            >
                {children}
            </div>
        );
    };

    render() {
        const {
            editable,
            dataIndex,
            title,
            record,
            index,
            handleSave,
            children,
            ...restProps
        } = this.props;
        return (
            <td {...restProps}>
                {editable ? (
                    <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
                ) : (
                    children
                )}
            </td>
        );
    }
}
